// Automatically included in './src/main.js'

import vue from './base';
import './meta';
export default vue;
